<template>
<!-- style="height:100%;min-height:77vh;width: 100%" -->
  <el-table
    :data="tableData"
     style="width: 100%"
    v-loading="isLoading"
    :height="tableHeight"
    :header-row-style="{ height: '0.3rem' }"
    :header-cell-style="{ backgroundColor: '#ffffff', color: '#666' }"
    element-loading-text="加载中"
    tooltip-effect="light"
    @selection-change="handleSelectionChange"
    @filter-change="handleFilterChange"
    @sort-change="sortChange"
    ref="multipleTable"
  >
    <el-table-column v-if="showSelection" align="center" type="selection" width="55"></el-table-column>
    <el-table-column
      v-for="item in tableOptions"
      :key="item.prop"
      :column-key="item.columnKey"
      :prop="item.prop"
      :label="item.label"
      :show-overflow-tooltip="item.showTooltip || false"
      :align="item.align || 'center'"
      :header-align="item.headerAlign || 'center'"
      :width="item.width || ''"
      :sortable="item.sortable || false"
      :filters="item.filters || null"
      :formatter="item.formatter || null"
    ></el-table-column>
    <el-table-column
      align="center"
      v-if="showOperate"
      fixed="right"
      label="操作"
      :width="operateWidth"
    >
      <template slot-scope="scope">
        <!-- <el-popover
          placement="left-start"
          width="160"
          trigger="hover"
          :open-delay="200"
          popper-class="btn-popover"
          v-if="defaultSlot"
        > -->
          <slot :scope="scope" name="default"></slot>
          <!-- <img src="../../assets/images/dot.png" slot="reference" alt="导航图标" class="operate-img" /> -->
        <!-- </el-popover> -->
        <!-- <slot :scope="scope" name="other" v-if="!defaultSlot"></slot> -->
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: "CommonTable",
  data() {
    return {
      multipleSelection: []
    };
  },
  props: {
    // 表头字段
    tableOptions: {
      type: Array
    },
    // 表格数据
    tableData: {
      type: Array
    },
    // 加载动画
    isLoading: {
      type: Boolean,
      default: true
    },
    // 加载动画
    showBorder: {
      type: Boolean,
      default: true
    },
    // 显示操作栏
    showOperate: {
      type: Boolean,
      default: true
    },
    // 编辑按钮
    showEdit: {
      type: Boolean,
      default: true
    },
    // 删除按钮
    showDelete: {
      type: Boolean,
      default: true
    },
    // 操作栏宽度
    operateWidth: {
      type: String,
      default: "100"
    },
    // 表格高度
    tableHeight: {
      type: String,
      default: "77vh"
    },
    // 多选
    showSelection: {
      type: Boolean,
      default: true
    },
    //是否显示默认的slot
    defaultSlot: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    // 多选框多选
    handleSelectionChange(val) {
      this.multipleSelection = val.map(item => item.id);
      // 存储批量删除的数组长度
      // this.$store.commit(
      //   'CHANGE_MULTIPLE_LENGTH',
      //   this.multipleSelection.length
      // )
      // 调用父组件方法
      this.$emit("handleSelectionChange", this.multipleSelection);
    },
    // 修改行数据
    changeRow(id) {
      this.$emit("changeRow", id);
    },
    // 删除行数据
    goToDel(id) {
      this.$emit("goToDel", id);
    },
    // 列过滤
    handleFilterChange(filters) {
      this.$emit("handleFilterChange", filters);
    },
    // 列排序
    sortChange(val) {
      this.$emit("sortChange", val);
    }
  }
};
</script>
<style lang="scss">
.el-table {
  margin: 0.15rem 0;
}
.operate-img {
  display: inline-block;
  width: 0.26rem;
  height: 0.26rem;
  vertical-align: middle;
  cursor: pointer;
}

.btn-popover {
  display: flex;
  flex-direction: column;
  padding-bottom: 0;

  .el-button {
    margin-bottom: 0.1rem;
  }

  .el-button + .el-button {
    margin-left: 0;
  }
}
.el-table__body-wrapper {
  height:0 !important;
}
</style>
